import React from "react";
import HeadRight from "../image/logo_mnd.png";
import HeadLeft from "../image/logo_jsolution.png";
import { Link } from "react-router-dom";

class Header extends React.Component {
  render() {
    return (
      <header>
        <img src={HeadRight} alt="대한민국 국방부 로고" className="logo_mnd" />
        <Link to="/">
          <div>국방 지능형 훈련 관리 플랫폼</div>
        </Link>
        <img src={HeadLeft} alt="제이솔루션 로고" className="logo_jsolution" />
      </header>
    );
  }
}

export default Header;
